import store from '../../../store';
import { getSourceSessionParams } from '..';

const ENABLED_ROLES = ['admin' , 'session ruler'];

export default async (session) => {
	if (!store.model.user) return false;
	
	const roleNames = await store.model.user.getRoleNames();
	
	const canCreateVote = ENABLED_ROLES.some(roleName => roleNames.some(name =>  name === roleName));
	
	const { foreignKey } = getSourceSessionParams(session);
	
	const votes = await store.model.Session.find({
		where: {
			and: [
				{ [foreignKey]: session.id },
				{ end: null },
			],
		}
	});

	const sessionId = votes.length > 0 ? votes[0].id : null;
	const canCreate = canCreateVote && votes.length === 0;
	
	console.log('canCreateVotingForSession', canCreate, 'canCreateVote', canCreateVote, 'sessionId', sessionId);
	
	return { canCreate, sessionId };
};
